import React from "react";
import { Box } from "@mui/material";
import { keyframes } from "@emotion/react";
import logoJesss from "../assets/logos/Logo_jesss.svg";

const pulse = keyframes`
  0%, 100% { 
    transform: scale(1);
    opacity: 1;
  }
  50% { 
    transform: scale(1.05);
    opacity: 0.9;
  }
`;

const ripple = keyframes`
  0% {
    transform: scale(0.8);
    opacity: 0.6;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
`;

const fadeInOut = keyframes`
  0%, 100% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.8;
  }
`;

const LoadingScreen: React.FC = () => {
  const isDark = localStorage.getItem("theme") === "dark";
  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 2000,
        backgroundColor: isDark ? "#141414" : "#f7f7f7",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Container com efeito de ondas */}
      <Box
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Círculos de ondas concêntricas */}
        {[0, 0.3, 0.6].map((delay, index) => (
          <Box
            key={index}
            sx={{
              position: "absolute",
              width: 200,
              height: 200,
              borderRadius: "50%",
              border: "2px solid #54398E",
              animation: `${ripple} 2s ease-out infinite`,
              animationDelay: `${delay}s`,
            }}
          />
        ))}

        {/* Círculo de fundo com gradiente suave */}
        <Box
          sx={{
            position: "absolute",
            width: 180,
            height: 180,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #e8e0f5 0%, #f5f2fa 100%)",
            animation: `${fadeInOut} 2s ease-in-out infinite`,
          }}
        />

        {/* Logo principal */}
        <Box
          component="img"
          src={logoJesss}
          alt="Jesss Logo"
          sx={{
            width: 140,
            height: "auto",
            position: "relative",
            zIndex: 10,
            animation: `${pulse} 2s ease-in-out infinite`,
            filter: "drop-shadow(0 4px 12px rgba(84, 57, 142, 0.15))",
          }}
        />
      </Box>
    </Box>
  );
};

export default LoadingScreen;
